import { useState } from "react";
import { toast } from "sonner";
import { AppLayout } from "@/components/AppLayout";
import { useAuth } from "@/context/AuthContext";
import api, { apiError } from "@/lib/api";

export default function Ajustes() {
  const { user } = useAuth();
  const [sent, setSent] = useState(false);

  const requestReset = async () => {
    try {
      await api.post("/auth/forgot-password", { email: user.email });
      setSent(true);
      toast.success("Le hemos enviado un enlace para cambiar su contraseña.");
    } catch (err) {
      toast.error(apiError(err));
    }
  };

  return (
    <AppLayout variant="firm">
      <div className="ddp-fade">
        <h1 className="ddp-serif" style={{ fontSize: "clamp(28px,4vw,40px)", color: "var(--burgundy-dark)", margin: 0, letterSpacing: "-.02em" }}>Ajustes</h1>
        <p style={{ color: "var(--muted)", fontSize: 15, marginTop: 8 }}>Datos de su cuenta.</p>
      </div>
      <div className="ddp-card" style={{ marginTop: 26, padding: 26, maxWidth: 560 }}>
        <dl style={{ display: "grid", gap: 18, margin: 0 }}>
          <div>
            <dt style={{ fontSize: 11, textTransform: "uppercase", letterSpacing: ".08em", color: "var(--muted)", fontWeight: 700, marginBottom: 5 }}>Nombre</dt>
            <dd style={{ margin: 0, fontSize: 16 }}>{user?.name}</dd>
          </div>
          <div>
            <dt style={{ fontSize: 11, textTransform: "uppercase", letterSpacing: ".08em", color: "var(--muted)", fontWeight: 700, marginBottom: 5 }}>Email profesional</dt>
            <dd style={{ margin: 0, fontSize: 16 }}>{user?.email}</dd>
          </div>
        </dl>
        <div className="ddp-hr" style={{ margin: "24px 0" }} />
        <div style={{ fontWeight: 700, marginBottom: 6 }}>Contraseña</div>
        <p style={{ fontSize: 14, color: "var(--muted)", margin: "0 0 14px", lineHeight: 1.55 }}>
          Le enviaremos un enlace seguro a su email para establecer una nueva contraseña.
        </p>
        <button onClick={requestReset} disabled={sent} data-testid="change-password-btn" className="ddp-btn ddp-btn-secondary ddp-btn-sm">
          {sent ? "Enlace enviado" : "Cambiar contraseña"}
        </button>
      </div>
    </AppLayout>
  );
}
